import React from 'react';
import FeatureSlider from './featureSlider';
import ReactDependentScript from "react-dependent-script";
import { NavLink } from 'react-router-dom';

class InfoPointsDDoS extends React.Component {

	render() {

		return (
			<React.Fragment>
				<div className="fullwidth light">
					<div className="row">
						<div className="six columns">
							<h3>Always-on DDoS Protection</h3>
							<p>A DDoS attack floods a service with unwanted traffic to exhaust bandwidth or server resources. Our protection is built into the network edge, so malicious packets are filtered before they reach your server and legitimate traffic can continue to flow.</p>
							<p>Mitigation is always on and automatic. No manual activation is required for normal use.</p>
						</div>
						<div className="six columns">
							<h3>Two Layers of Mitigation</h3>
							<p>We use a layered approach. High-capacity edge filtering stops volumetric floods and amplification traffic, while dedicated anti-DDoS systems handle L4 protocol attacks such as TCP SYN/ACK and GRE floods. This combination mitigates the majority of real-world attacks without impacting your services.</p>
							<span className="left readmore" id="readmore" onClick={this.toggleAnimation}>Read more <i className="fa-regular fa-caret-square-right" id="caret" aria-hidden="true"></i></span>
						</div>
					</div>
					<div className="row expandableContent margintop" id="ddos-protection-info">
						<div className="four columns">
							<h5>Volumetric Attacks</h5>
							<hr className="grey" />
							<div className="left paddingright"><i className="fa fa-bar-chart fa-5x" aria-hidden="true"></i></div>
							<p>Volumetric attacks are high-bandwidth floods designed to saturate links and upstream capacity. Common examples include UDP amplification and ICMP floods. These attacks are measured in bits per second (Gbps) and are best stopped at the edge before they reach your server.</p>
						</div>
						<div className="four columns">
							<h5>Protocol Attacks</h5>
							<hr className="grey" />
							<div className="left paddingright"><i className="fa fa-chain-broken fa-5x" aria-hidden="true"></i></div>
							<p>Protocol attacks aim to exhaust network state and server resources rather than bandwidth. Common examples include SYN floods and other packet floods that target L4 behavior. These attacks are measured in packets per second (Pps).</p>
						</div>
						<div className="four columns">
							<h5>Application Layer Attacks</h5>
							<hr className="grey" />
							<div className="left paddingright"><i className="fa fa-file-code-o fa-5x" aria-hidden="true"></i></div>
							<p>Application-layer attacks target specific services such as HTTP by mimicking legitimate requests. These are usually lower bandwidth but harder to distinguish. Network filtering keeps the link clean, while application-level controls like rate limiting and caching handle the rest.</p>
						</div>
					</div>
				</div>
				<ReactDependentScript scripts={["/js/jquery-3.4.1.js"]}>
					<FeatureSlider />
				</ReactDependentScript>
				<div className="fullwidth dark">
					<div className="row paddingtop">
						<div className="twelve columns">
							<h3><span className="colored">Included Protection</span> for Dedicated and Confidential Servers</h3>
							<hr className="black" />
						</div>
					</div>
					<div className="row ddos-widget-row">
						<div className="six columns">
							<NavLink className="panel callout panel-link ddos-widget" to="/en/dedicated-servers-switzerland">
								<h3>Dedicated Servers</h3>
								<p>Every dedicated server is connected to our protected network with always-on DDoS mitigation included. Malicious traffic is filtered before it reaches your server, so your services stay reachable during attacks.</p>
								<span className="readmore ddos-widget-cta">Explore Dedicated Servers <i className="fa-regular fa-square-caret-right"></i></span>
							</NavLink>
						</div>
						<div className="six columns">
							<NavLink className="panel callout panel-link ddos-widget" to="/en/confidential-servers-switzerland">
								<h3>Confidential Servers</h3>
								<p>Confidential computing servers run behind the same DDoS protection layer, included by default. You get hardware-encrypted workloads with network-level mitigation built in.</p>
								<span className="readmore ddos-widget-cta">Explore Confidential Servers <i className="fa-regular fa-square-caret-right"></i></span>
							</NavLink>
						</div>
					</div>
					<div className="row">
						<div className="twelve columns">
							<div className="panel callout ddos-protection-note">
								<p>Protection is always on and automatic. It targets the most common volumetric and protocol floods, which makes it sufficient for most DDoS threats without extra steps.</p>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
	toggleAnimation = (e) => {
		document.getElementById('ddos-protection-info').classList.toggle('expanded')
	}
}

export default InfoPointsDDoS
